
import React from 'react';

import { Link } from 'react-router-dom';

function PricingAndPrograms() {
  return (
    <>

      <div className="bg-[#F9FAFB] min-h-screen py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-[#102A43] mb-4">AASC Programs</h1>
            <p className="text-xl text-gray-600">Standardized verification for any organization using AI.</p>
          </div>

          <div className="grid lg:grid-cols-4 gap-6">
            
            <div className="bg-white border border-gray-200 shadow-sm flex flex-col">
              <div className="p-6 border-b border-gray-100">
                <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2">Step 1</h2>
                <h3 className="text-xl font-bold text-[#102A43] mb-4">Free Tools</h3>
                <div className="mb-4"><span className="text-2xl font-bold text-[#102A43]">$0</span></div>
                <p className="text-sm text-gray-600">Start learning about accountability.</p>
              </div>
              <div className="p-6 border-t border-gray-100 mt-auto">
                <Link to="/standards" className="block w-full text-center py-2 bg-gray-100 text-[#102A43] font-bold rounded-sm hover:bg-gray-200 transition-colors">View Standards</Link>
              </div>
            </div>

            <div className="bg-white border border-gray-200 shadow-sm flex flex-col">
              <div className="p-6 border-b border-gray-100">
                <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2">Step 2</h2>
                <h3 className="text-xl font-bold text-[#102A43] mb-4">AI Accountability Documentation System</h3>
                <div className="mb-4"><span className="text-2xl font-bold text-[#102A43]">$97</span><span className="text-gray-500 text-sm"> / once</span></div>
                <p className="text-sm text-gray-600">Templates to organize your governance.</p>
              </div>
              <div className="p-6 border-t border-gray-100 mt-auto">
                <Link to="/documentation-system" className="block w-full text-center py-2 border border-gray-900 text-[#102A43] font-bold rounded-sm hover:bg-[#F9FAFB] transition-colors">Get System</Link>
              </div>
            </div>

            <div className="bg-white border border-gray-200 shadow-sm flex flex-col">
              <div className="p-6 border-b border-gray-100">
                <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2">Step 3</h2>
                <h3 className="text-xl font-bold text-[#102A43] mb-4">AI Accountability Assessment</h3>
                <div className="mb-4"><span className="text-2xl font-bold text-[#102A43]">$297</span><span className="text-gray-500 text-sm"> / once</span></div>
                <p className="text-sm text-gray-600">Evaluate your organization's readiness.</p>
              </div>
              <div className="p-6 border-t border-gray-100 mt-auto">
                <Link to="/assessment/form" className="block w-full text-center py-2 border border-gray-900 text-[#102A43] font-bold rounded-sm hover:bg-[#F9FAFB] transition-colors">Take Assessment</Link>
              </div>
            </div>

            <div className="bg-white border-2 border-blue-900 shadow-md transform lg:scale-105 z-10 flex flex-col">
              <div className="bg-[#2F80ED] p-6 text-white">
                <h2 className="text-sm font-bold text-blue-200 uppercase tracking-wide mb-2">Step 4</h2>
                <h3 className="text-xl font-bold text-white mb-4">AASC Accountability Declaration</h3>
                <div className="mb-4"><span className="text-2xl font-bold text-white">$997</span><span className="text-blue-200 text-sm"> / year</span></div>
                <p className="text-sm text-blue-100">Public commitment and registry listing.</p>
              </div>
              <div className="p-6 border-t border-gray-100 mt-auto">
                <Link to="/apply" className="block w-full text-center py-2 bg-[#2F80ED] text-white font-bold rounded-sm hover:bg-[#2563eb] transition-colors">Start Declaration</Link>
              </div>
            </div>

          </div>

          <div className="mt-12 bg-gray-100 border border-gray-200 flex flex-col md:flex-row items-center justify-between p-8 rounded-sm">
             <div>
               <h3 className="text-xl font-bold text-[#102A43] mb-2">Enterprise Assessment</h3>
               <p className="text-[#64748B]">Contact us for multi-division assessments and custom governance frameworks.</p>
             </div>
             <a href="mailto:contact@aiaccountabilitycouncil.com" className="mt-4 md:mt-0 px-6 py-3 bg-[#2F80ED] text-white font-bold rounded-sm hover:bg-[#2563eb] transition-colors">
               Contact Us
             </a>
          </div>

        </div>
      </div>
    </>
  );
}

export default PricingAndPrograms;
